import i18n from 'i18n'
import { MeasurementsSystem } from 'screens/UserManager/UserManager.types'

export const getFormattedUnit = (unit: string): string => {
  switch (unit) {
    case 'KG':
    case 'KGM':
      return 'kg'
    case 'LB':
    case 'LBR':
      return 'lb'
    case 'CM':
      return 'cm'
    case 'IN':
      return 'in'
    case 'M':
      return 'm'
    case 'FT':
      return 'ft'
    case 'M3':
    case 'MTQ':
      return 'm³'
    case 'FT3':
      return 'ft³'
    case 'L':
      return 'l'
    case 'GAL':
      return 'gal'
    case 'MTR':
    case 'LDM':
      return i18n.t('screens.cs.trip_details.card.ldm')
    case 'C':
      return '°C'
    case 'F':
      return '°F'
    default:
      return unit
  }
}

export const convertCelsiusToFahrenheit = (celsius: number) =>
  celsius * 9 / 5 + 32

export const convertCentimetersToInches = (centimeters: number) =>
  centimeters * 0.3937007874

export const convertCubicMetersToCubicFeet = (cubicMeters: number) =>
  cubicMeters * 35.3146667

export const convertLitersToGallons = (liters: number) =>
  liters * 0.264172

export const convertKilogramsToPounds = (kilograms: number) =>
  kilograms * 2.20462262

export const convertLoadingMetersToLinearFeet = (loadingMeters: number) =>
  loadingMeters * 3.280839895

export const getWeightMeasurement = (weight: number, measurementsSystem: MeasurementsSystem) =>
  formatMeasurement(measurementsSystem === MeasurementsSystem.IMPERIAL ? convertKilogramsToPounds(weight) : weight)

export const getWeightUnit = (measurementsSystem: MeasurementsSystem) =>
  measurementsSystem === MeasurementsSystem.IMPERIAL ? 'LB' : 'KG'

export const getVolumeMeasurement = (volume: number, measurementsSystem: MeasurementsSystem) =>
  formatMeasurement(measurementsSystem === MeasurementsSystem.IMPERIAL ? convertCubicMetersToCubicFeet(volume) : volume)

export const getVolumeUnit = (measurementsSystem: MeasurementsSystem) =>
  measurementsSystem === MeasurementsSystem.IMPERIAL ? 'FT3' : 'M3'

export const getFluidsVolumeMeasurement = (volume: number, measurementsSystem: MeasurementsSystem) =>
  formatMeasurement(measurementsSystem === MeasurementsSystem.IMPERIAL ? convertLitersToGallons(volume) : volume)

export const getFluidsVolumeUnit = (measurementsSystem: MeasurementsSystem) =>
  measurementsSystem === MeasurementsSystem.IMPERIAL ? 'GAL' : 'L'

export const getDimensionMeasurement = (dimension: number, measurementsSystem: MeasurementsSystem) =>
  formatMeasurement(measurementsSystem === MeasurementsSystem.IMPERIAL ? convertCentimetersToInches(dimension) : dimension)

export const getDimensionUnit = (measurementsSystem: MeasurementsSystem) =>
  measurementsSystem === MeasurementsSystem.IMPERIAL ? 'IN' : 'CM'

export const getLoadingMetersMeasurement = (loadingMeters: number, measurementsSystem: MeasurementsSystem) =>
  formatMeasurement(measurementsSystem === MeasurementsSystem.IMPERIAL ? convertLoadingMetersToLinearFeet(loadingMeters) : loadingMeters)

export const getLoadingMetersUnit = (measurementsSystem: MeasurementsSystem) =>
  measurementsSystem === MeasurementsSystem.IMPERIAL ? 'LF' : 'LDM'

export const getTemperatureMeasurement = (temperature: number, measurementsSystem: MeasurementsSystem) =>
  formatMeasurement(measurementsSystem === MeasurementsSystem.IMPERIAL ? convertCelsiusToFahrenheit(temperature) : temperature)

export const getTemperatureUnit = (measurementsSystem: MeasurementsSystem) =>
  measurementsSystem === MeasurementsSystem.IMPERIAL ? 'F' : 'C'

export const formatMeasurement = (value: number) =>
  new Intl.NumberFormat(i18n.language, {
    maximumFractionDigits: 2,
  }).format(value)
